// import React, { useState, useEffect } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrashAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
// import { toast } from 'react-toastify';

// const Product = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [selectedAd, setSelectedAd] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [lastPage, setLastPage] = useState(1);

//   const fetchCategories = async (page) => {
//     setLoading(true);
//     try {
//       const token = JSON.parse(localStorage.getItem('token'));
//       console.log("token",token)
//       const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads?page=${page}`, {
//         method: 'GET',
//         headers: {
//           Accept: 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.ok) {
//         const data = await response.json();
//         console.log("data.ads.data",data.ads.data)
//         setCategories(data.ads.data || []);
//         setLastPage(data.ads.last_page || 1);
//       } else {
//         toast.error('Failed to fetch ads.');
//       }
//     } catch (err) {
//       toast.error('Error fetching ads.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCategories(currentPage);
//   }, [currentPage]);

//   const handleDeleteClick = (ad) => {
//     setSelectedAd(ad);
//     setShowModal(true);
//   };

//   const confirmDelete = async () => {
//     if (!selectedAd) return;

//     setLoading(true);
//     try {
//       const token = JSON.parse(localStorage.getItem('token'));
//       const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${selectedAd.id}`, {
//         method: 'DELETE',
//         headers: {
//           Accept: 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (response.ok) {
//         toast.success('Ad deleted successfully!');
//         setCategories(categories.filter((ad) => ad.id !== selectedAd.id));
//         setShowModal(false);
//       } else {
//         toast.error('Failed to delete ad.');
//       }
//     } catch (err) {
//       toast.error('Error deleting ad.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApproveClick = async (ad) => {
//     setLoading(true);
//     try { 
      
//       const token = JSON.parse(localStorage.getItem('token'));
//       const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${ad.id}/approve`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });
// console.log("response",response)
//       if (response.ok) {
//         toast.success('Ad approved successfully!');
//         fetchCategories(currentPage);
//       } else {
//         toast.error('Failed to approve ad.');
//       }
//     } catch (err) {
//       toast.error('Error approving ad.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDisapproveClick = async (ad) => {
//     setLoading(true);
//     try {
//       const token = JSON.parse(localStorage.getItem('token'));
//       const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${ad.id}/disapprove`, {
//         method: 'POST',
//         headers: {
//           Accept: 'application/json',
//           Authorization: `Bearer ${token}`,
//         },
//       });
// console.log("response",response)
//       if (response.ok) {
//         toast.success('Ad disapproved successfully!');
//         fetchCategories(currentPage);
//       } else {
//         toast.error('Failed to disapprove ad.');
//       }
//     } catch (err) {
//       toast.error('Error disapproving ad.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const cancelDelete = () => {
//     setShowModal(false);
//     setSelectedAd(null);
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < lastPage) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   return (
//     <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif',flex:1 }}>
//       <h1 style={{ textAlign: 'center', marginBottom: '20px', color: '#9a3939' }}>Ads Dashboard</h1>

//               {loading && (
//           <div className="loader-overlay">
//             <div className="loader"></div>
//           </div>
//         )}

//       {!loading && error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}

//       {!loading && categories.length > 0 && (
//         // <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
//           {categories.map((ad) => (
//             <div
//               key={ad.id}
//               // style={{
//               //   border: '1px solid #ddd',
//               //   borderRadius: '8px',
//               //   padding: '15px',
//               //   width: 'calc(33% - 20px)',
//               //   boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
//               //   backgroundColor: '#fff',
//               // }}
//               style={{
//                 border: '1px solid #ddd',
//                 borderRadius: '8px',
//                 padding: '15px',
//                 width: 'calc(33% - 20px)', // This will take up 1/3rd of the width of the container
//                 boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
//                 backgroundColor: '#fff',
//                 marginBottom: '20px', // Space below each item
//               }}
//             >
//               <img
//                 src={
//                   ad.media && ad.media[0]
//                     ? `https://dashboard.onyxen-regalia.com/backend/storage/${ad.media[0].file_path}`
//                     : 'logosplash.png'
//                 }
//                 alt={ad.title?.en || 'Ad'}
//                 style={{
//                   width: '100%',
//                   height: '150px',
//                   objectFit: 'cover',
//                   borderRadius: '4px',
//                   marginBottom: '10px',
//                 }}
//               />
//               <h3 style={{ fontSize: '18px', color: '#9a3939' }}>
//                 {ad.title?.en || ''} - {ad.title?.ar || ''}
//               </h3>
//               <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
//                 <strong>ID:</strong> {ad.id}
//               </p>
//               <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
//                 <strong>Price:</strong> {ad.price || 'N/A'}
//               </p>
//               <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
//                 <strong>Status:</strong> {ad.is_approved == '1' ? 'Approved' : 'Pending'}
//               </p>
//               <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
//                 <strong>User:</strong> {ad.user?.name || 'N/A'}
//               </p>
//               <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
//                 {ad.is_approved == '0' && (
//                   <>
//                     <button
//                       style={{
//                         padding: '5px 10px',
//                         border: 'none',
//                         borderRadius: '4px',
//                         backgroundColor: '#4caf50',
//                         color: '#fff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleApproveClick(ad)}
//                     >
//                       <FontAwesomeIcon icon={faCheck} /> Approve
//                     </button>
//                     <button
//                       style={{
//                         padding: '5px 10px',
//                         border: 'none',
//                         borderRadius: '4px',
//                         backgroundColor: '#f44336',
//                         color: '#fff',
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => handleDisapproveClick(ad)}
//                     >
//                       <FontAwesomeIcon icon={faTimes} /> Disapprove
//                     </button>
//                   </>
//                 )}
//                 <button
//                   style={{
//                     padding: '5px 10px',
//                     border: 'none',
//                     borderRadius: '4px',
//                     backgroundColor: '#9a3939',
//                     color: '#fff',
//                     cursor: 'pointer',
//                   }}
//                   onClick={() => handleDeleteClick(ad)}
//                 >
//                   <FontAwesomeIcon icon={faTrashAlt} /> Delete
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {!loading && categories.length === 0 && (
//         <div style={{ textAlign: 'center', fontSize: '18px', color: '#999' }}>No ads found.</div>
//       )}

//       {lastPage > 1 && (
//         <div style={{ marginTop: '20px', textAlign: 'center' }}>
//           <button
//             onClick={handlePreviousPage}
//             disabled={currentPage === 1}
//             style={{
//               marginRight: '10px',
//               padding: '5px 10px',
//               backgroundColor: '#9a3939',
//               color: '#fff',
//               border: 'none',
//               borderRadius: '4px',
//               cursor: 'pointer',
//             }}
//           >
//             Previous
//           </button>
//           <span style={{ fontSize: '14px' }}>
//             Page {currentPage} of {lastPage}
//           </span>
//           <button
//             onClick={handleNextPage}
//             disabled={currentPage === lastPage}
//             style={{
//               marginLeft: '10px',
//               padding: '5px 10px',
//               backgroundColor: '#9a3939',
//               color: '#fff',
//               border: 'none',
//               borderRadius: '4px',
//               cursor: 'pointer',
//             }}
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {showModal && (
//         <div
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             width: '100%',
//             height: '100%',
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: '#fff',
//               padding: '20px',
//               borderRadius: '8px',
//               textAlign: 'center',
//               maxWidth: '400px',
//               width: '90%',
//             }}
//           >
//             <h3 style={{ marginBottom: '20px' ,color:"#000"}}>Are you sure you want to delete this ad?</h3>
//             <button
//               onClick={cancelDelete}
//               style={{
//                 marginRight: '10px',
//                 padding: '5px 10px',
//                 backgroundColor: '#555',
//                 color: '#fff',
//                 border: 'none',
//                 borderRadius: '4px',
//                 cursor: 'pointer',
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={confirmDelete}
//               style={{
//                 padding: '5px 10px',
//                 backgroundColor: '#9a3939',
//                 color: '#fff',
//                 border: 'none',
//                 borderRadius: '4px',
//                 cursor: 'pointer',
//               }}
//             >
//               Delete
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Product;
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

const Product = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [ShowDeleteModal, setShowDeleteModal] = useState(false);
  
  const [selectedAd, setSelectedAd] = useState(null);
  const [reason, setReason] = useState(''); // Added state for reason
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null); 
  const fetchCategories = async (page) => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("token",token)
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads?page=${page}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data.ads.data",data.ads.data)
        setCategories(data.ads.data || []);
        setLastPage(data.ads.last_page || 1);
      } else {
        toast.error('Failed to fetch ads.');
      }
    } catch (err) {
      toast.error('Error fetching ads.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories(currentPage);
  }, [currentPage]);

  const handleDeleteClick = (ad) => {
    setSelectedAd(ad);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedAd) return;
    setShowDeleteModal(false);
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${selectedAd.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        toast.success('Ad deleted successfully!');
        setCategories(categories.filter((ad) => ad.id !== selectedAd.id));
      } else {
        toast.error('Failed to delete ad.');
      }
    } catch (err) {
      toast.error('Error deleting ad.');
    } finally {
      setLoading(false);
    }
  };

  const handleApproveClick = async (ad) => {
    setLoading(true);
    try { 
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${ad.id}/approve`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response",response)
      if (response.ok) {
        toast.success('Ad approved successfully!');
        fetchCategories(currentPage);
      } else {
        toast.error('Failed to approve ad.');
      }
    } catch (err) {
      toast.error('Error approving ad.');
    } finally {
      setLoading(false);
    }
  };

  const handleDisapproveClick = (ad) => {
    setSelectedAd(ad);
    setShowModal(true); // Show modal when disapproving
  };

  const cancelDisApprove = () => {
    setShowModal(false);
    setSelectedAd(null);
    setReason(''); // Clear reason input
  };
  const cancelDelete = () => {
    setShowDeleteModal(false);
    setSelectedAd(null);
  };

  const confirmDisapprove = async () => {
    // if (!selectedAd || !reason) {
      if (!selectedAd) {
      // toast.error('Please provide a reason.');
      return;
    }

    setLoading(true);
    setShowModal(false);

    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const data = {
        reject_reason: reason ? reason :'0' ,
      };
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/ads/${selectedAd.id}/disapprove`, {
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', 
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        console.log("okkkkkkkkk")
        toast.success('Ad disapproved successfully!');
        fetchCategories(currentPage);
        setReason(''); // Clear reason input
      } else {
        toast.error('Failed to disapprove ad.');
      }
    } catch (err) {
      toast.error('Error disapproving ad.');
    } finally {
      setLoading(false);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleImageClick = (image) => {
    setSelectedImage(image); // Set the clicked image to be shown in large view
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', flex: 1 }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px', color: '#9a3939' }}>Ads Dashboard</h1>

      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}

      {!loading && error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}

      {!loading && categories.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between' }}>
          {categories.map((ad) => (
            <div
              key={ad.id}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '15px',
                width: 'calc(33% - 20px)',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginBottom: '20px',
              }}
            >
              <img
                src={
                  ad.media && ad.media[0]
                    ? `https://dashboard.onyxen-regalia.com/backend/storage/${ad.media[0].file_path}`
                    : 'logosplash.png'
                }
                alt={ad.title?.en || 'Ad'}
                style={{
                  width: '100%',
                  height: '150px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  marginBottom: '10px',
                  
                }}
                onClick={() => handleImageClick(ad.media[0])} 
              />

{ad.media && ad.media.length > 1 && (
      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
        {ad.media.slice(1).map((image, index) => (
          <img
            key={index}
            src={`https://dashboard.onyxen-regalia.com/backend/storage/${image.file_path}`}
            alt={`Thumbnail ${index + 1}`}
            style={{
              width: '50px',
              height: '50px',
              objectFit: 'cover',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
            onClick={() => handleImageClick(image)} // Open clicked image in large view
          />
        ))}
      </div>
    )}
              <h3 style={{ fontSize: '18px', color: '#9a3939' }}>
                {ad.title?.en || ''} - {ad.title?.ar || ''}
              </h3>
              <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
                <strong>ID:</strong> {ad.id}
              </p>
              <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
                <strong>Price:</strong> {ad.price || 'N/A'}
              </p>
              <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
                <strong>Status:</strong> {ad.is_approved == '1' ? 'Approved' : ad.reject_reason ?  'disapproved':  'Pending'}
              </p>
              <p style={{ fontSize: '14px', marginBottom: '5px', color: '#555' }}>
                <strong>User:</strong> {ad.user?.name || 'N/A'}
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                {ad.is_approved == '0' && (
                  <>
                    <button
                      style={{
                        padding: '5px 10px',
                        border: 'none',
                        borderRadius: '4px',
                        backgroundColor: '#4caf50',
                        color: '#fff',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleApproveClick(ad)}
                    >
                      <FontAwesomeIcon icon={faCheck} /> Approve
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        border: 'none',
                        borderRadius: '4px',
                        backgroundColor: '#f44336',
                        color: '#fff',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleDisapproveClick(ad)}
                    >
                      <FontAwesomeIcon icon={faTimes} /> Disapprove
                    </button>
                  </>
                )}
                <button
                  style={{
                    padding: '5px 10px',
                    border: 'none',
                    borderRadius: '4px',
                    backgroundColor: '#9a3939',
                    color: '#fff',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDeleteClick(ad)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && categories.length === 0 && (
        <div style={{ textAlign: 'center', fontSize: '18px', color: '#999' }}>No ads found.</div>
      )}

      {lastPage > 1 && (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            style={{
              marginRight: '10px',
              padding: '5px 10px',
              backgroundColor: '#9a3939',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Previous
          </button>
          <span style={{ fontSize: '14px' }}>
            Page {currentPage} of {lastPage}
          </span>
          <button
            onClick={handleNextPage}
            disabled={currentPage === lastPage}
            style={{
              marginLeft: '10px',
              padding: '5px 10px',
              backgroundColor: '#9a3939',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            Next
          </button>
        </div>
      )}

      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              maxWidth: '400px',
              width: '90%',
            }}
          >
            <h3 style={{ marginBottom: '20px', color: "#000" }}>Are you sure you want to disapprove this ad?</h3>
            <textarea
              placeholder="Enter reason for disapproval"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{
                width: '100%',
                height: '100px',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                marginBottom: '20px',
                fontSize: '14px',
                color: '#555',backgroundColor: '#fff'
              }}
            />
            <div>
              <button
                onClick={cancelDisApprove}
                style={{
                  marginRight: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#555',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDisapprove}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#9a3939',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Disapprove
              </button>
            </div>
          </div>
        </div>
      )}



{ShowDeleteModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              maxWidth: '400px',
              width: '90%',
            }}
          >
            <h3 style={{ marginBottom: '20px', color: "#000" }}>Are you sure you want to Delete this ad?</h3>
          
            <div>
              <button
                onClick={cancelDelete}
                style={{
                  marginRight: '10px',
                  padding: '5px 10px',
                  backgroundColor: '#555',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                style={{
                  padding: '5px 10px',
                  backgroundColor: '#9a3939',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}


{selectedImage && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}
    onClick={() => setSelectedImage(null)} // Close when clicked outside the image
  >
    <img
      src={`https://dashboard.onyxen-regalia.com/backend/storage/${selectedImage.file_path}`}
      alt="Large view"
      style={{
        maxWidth: '80%',
        maxHeight: '80%',
        objectFit: 'contain',
        borderRadius: '8px',
      }}
    />
  </div>
)}
      
    </div>
  );
};

export default Product;
